import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {AccountService} from './admin/auth/account.service';
import {LangService} from './admin/services/lang.service';
import {KeycloakService} from 'keycloak-angular';
import { HttpClient } from '@angular/common/http';
import {IdleService} from './admin/services/idle.service';
import {IdleWarningDialogComponent} from './admin/components/idle-warning-dialog/idle-warning-dialog.component';
import {WebSocketService} from './admin/services/websocket.service';
import {ActivityTypeEnum, GatewayPublicUserService, GatewayUserActivityService} from "@tj/tj-dmp-lib-api";

@Component({
    selector: 'dmp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'dmp-ui';

    @ViewChild(IdleWarningDialogComponent) idleWarningDialog: IdleWarningDialogComponent;

    constructor(
        private keycloakService: KeycloakService,
        private router: Router,
        private accountService: AccountService,
        private webSocketService: WebSocketService,
        private langService: LangService,
        private location: Location,
        private readonly gatewayPublicUserService: GatewayPublicUserService,
        private readonly gatewayUserActivityService: GatewayUserActivityService,
        protected readonly keycloak: KeycloakService,
        private http: HttpClient,
        private idleService: IdleService,
    ) {

    }

    ngOnInit(): void {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map((data) => {
                return data;
            })
        );

        // Initialize language from user preference after identity retrieval.
        this.accountService.identity().then(user => {
            if (user !== null) {
                this.gatewayPublicUserService.getCurrentUser().subscribe({
                    next: (currentUser) => this.langService.applyUserLanguage(currentUser?.langKey || user.langKey),
                    error: () => this.langService.applyUserLanguage(user.langKey),
                });
                this.gatewayUserActivityService.logCustomActivity(ActivityTypeEnum.LOGIN).subscribe();
                this.webSocketService.connect(user.id);
                this.idleService.startTimer();
            } else {
                this.langService.init();
            }
        }).catch(() => {
            this.langService.init();
        });

        this.idleService.onIdleWarning.subscribe(() => {
            this.idleWarningDialog.showDialog();
        });
        this.idleService.onIdleTimeout.subscribe(() => {
            this.keycloak.logout();
        });

    }

    ngOnDestroy(): void {
    }
}
